import React from 'react';
import { CardSearch } from './components/CardSearch';
import './App.css';

function App() {
  return (
    <div className="App">
      <CardSearch />
    </div>
  );
}

export default App;

